<template>
  <div id="header">
    <div class="wrap">
      <div class="nav">
        <div class="logo">
          <router-link to="/">
            <img
              src="@/assets/images/header/logo1.svg"
              alt="logo"
            >
          </router-link>
        </div>
        <router-link
          to="/#service"
          class="item"
        >服务项目</router-link>
        <router-link
          to="/#cases"
          class="item"
        >案例展示</router-link>
        <router-link
          to="/#honor"
          class="item"
        >资质荣耀</router-link>
        <router-link
          to="/about-us"
          class="item"
        >关于我们</router-link>
      </div>
      <div class="tel">
        <img
          src="@/assets/images/header/phone.svg"
          alt="电话"
        >
        <span>0577-88587692</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderBar"
};
</script>

<style lang="less" scoped>
#header {
  height: 90px;
  box-shadow: 0 1px 1px #d3d5d8;
  font-size: 16px;
  min-width: 980px;
  // 固定
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 99;

  .wrap {
    display: flex;
    justify-content: space-between;
    padding-left: 30px;
    padding-right: 30px;

    .nav {
      display: flex;
      justify-content: space-between;

      .logo {
        margin-top: 20px;
        margin-right: 50px;

        a {
          line-height: 30px;
        }

        img {
          width: 152px;
          height: 40px;
          margin-bottom: -5px;
        }
      }

      .item.one {
        margin-left: 50px;

        a {
          color: #142655;
        }
      }

      .item {
        cursor: pointer;
        width: 70px;
        margin: 0 30px;
        color: #142655;
        align-self: stretch;
        line-height: 90px;
        text-align: justify;
        text-justify: distribute-all-lines;
        /*ie6-8*/
        text-align-last: justify;
        /* ie9*/
        -moz-text-align-last: justify;
        /*ff*/
        -webkit-text-align-last: justify;
        /*chrome 20+*/

        &.active {
          border-bottom: 2px solid #375ff1;
        }

        &.router-link-active {
          border-bottom: 2px solid #375ff1;
        }

        &:hover {
          border-bottom: 2px solid #375ff1;
        }

        a {
          text-decoration: none;

          &:visited {
            color: #142655;
          }
        }
      }
    }

    .tel {
      margin-right: 20px;
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 18px;
      }

      span {
        margin-left: 10px;
        color: #375ff1;
      }
    }
  }
}
</style>